/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BenefitsChartHeader_tradeFirm$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BenefitsChart_tradeFirm$ref: FragmentReference;
export type BenefitsChart_tradeFirm = {|
  +$fragmentRefs: BenefitsChartHeader_tradeFirm$ref,
  +$refType: BenefitsChart_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BenefitsChart_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BenefitsChartHeader_tradeFirm",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3d099ee43f7d2f4cce2a8042eac4275b';
module.exports = node;
